import { apiClient } from "@/services/api";
import { V3 } from "@/services/api/apiPrefix";

/**
 * Catálogo do storefront buscado pelo SLUG da loja (menuus-core-api).
 *
 * Substitui a "hash" (pointOfSaleId em JWT) na URL do catálogo por um slug
 * legível. As 3 rotas são @Public no backend — não exigem token.
 *
 * Rollback: trocar `${V3}` por "/api" (mas as rotas /catalog só existem no v3).
 */

/**
 * Resolve o slug da loja para os dados do point-of-sale.
 * O `pointOfSale.id` volta em JWT — é ele que o storefront usa daqui pra frente
 * (design-system, opening-hours, carrinho, checkout continuam com esse JWT).
 *
 * @param {string} slug
 * @returns {Promise<{ pointOfSale: { id: string, corporateName: string, phone: string|null, [k:string]: unknown } }>}
 */
export async function getCatalogBySlug(slug) {
  const { data } = await apiClient.get(`${V3}/catalog/${slug}`);
  if (!data?.success) {
    throw new Error(data?.message || "Loja não encontrada");
  }
  return data.response;
}

/**
 * Lista paginada de produtos da loja. Mesmo shape do legado
 * `GET /api/sale/product/v2/list` (`{ response: { items, pagination } }`).
 *
 * @param {string} slug
 * @param {{ page?: number, searchTerm?: string, categoryId?: string, categoryType?: string }} [opts]
 */
export async function listCatalogProductsBySlug(slug, opts = {}) {
  const params = {};
  if (opts.page) params.page = opts.page;
  if (opts.searchTerm) params.searchTerm = opts.searchTerm;
  if (opts.categoryId) params.categoryId = opts.categoryId;
  if (opts.categoryType) params.categoryType = opts.categoryType;

  const { data } = await apiClient.get(`${V3}/catalog/${slug}/products`, {
    params,
  });
  return data;
}

/**
 * Lista (flat) de categorias da loja. Mesmo shape do legado
 * `GET /api/sale/product-category/list/:id` (`{ response: [...] }`).
 *
 * @param {string} slug
 */
export async function listCatalogCategoriesBySlug(slug) {
  const { data } = await apiClient.get(`${V3}/catalog/${slug}/categories`);
  return data;
}
